export const routes = {
  user_module_saicaReport_home: {
    path: 'saica-reports/:moduleBridgeHex/home/:level/',
    parameters: {
      moduleBridgeHex: undefined,
      level: 4,
    },
  },
  user_module_saicaReport_report: {
    path: 'saica-reports/:moduleBridgeHex/report/:reportHex/',
    parameters: {
      moduleBridgeHex: undefined,
      reportHex: undefined,
    },
  },
  user_error: {
    path: 'error',
  },
};
